<div class="ca-main">
  <h2>{{ "USER_SETTINGS.VIEW" | translate }}</h2>
  <ngmy-table-filter class="filter" (changed)="nameFilterChanged($event)"></ngmy-table-filter>
  <app-button-toggle [items]="toggles" (buttonChange)="setTab($event)"></app-button-toggle>
  <table-expandable-rows
    *ngIf="config"
    class="table-expandable-rows"
    [columnsData]="config.columns"
    [nestedColumns]="config.nestedColumns"
    [nestedTemplate]="config.component"
    [module]="module"
    [pagingConfig]="pagingConfig"
    [disableSort]="false"
    [sortActive]="'regionName'"
    [sortDirection]="'asc'"
  ></table-expandable-rows>
  <button ene-filled-button icon="ec_data-import" (click)="downloadXslx()">
    {{ "USER_SETTINGS.DOWNLOAD_BUTTON" | translate | uppercase }}
  </button>
</div>
